// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","130":"b82d9cff","378":"1200a36e","779":"1b4a98bd","788":"d8094acd","854":"e4f3059a","892":"be73317d","899":"412a72a3","950":"78ccf31c"}[chunkId] + ".chunk.js";
};